import { useRoute, useRouter, computed } from "#imports";
export function useQueryString(key, defaultValue = "", removeOtherKeys = ["page"]) {
  const route = useRoute();
  const router = useRouter();
  return computed({
    get() {
      const value = route.query[typeof key === "string" ? key : key.value];
      if (!value) {
        return defaultValue;
      }
      if (Array.isArray(value)) {
        return value[0] || defaultValue;
      }
      return value;
    },
    set(newValue) {
      router.push({
        query: {
          // Use the current query parameters.
          ...route.query,
          // Merge the keys to remove.
          ...Object.fromEntries(removeOtherKeys.map((key2) => [key2, void 0])),
          // Update the new query value.
          [typeof key === "string" ? key : key.value]: newValue || void 0
        }
      });
    }
  });
}
